import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();
  return (
    <img
      className={classes.img}
      src="/aunoa-logo.png"
      alt="Aunoa"
    />
  );
};

export default LogoFull;
